import { render, staticRenderFns } from "./data3.vue?vue&type=template&id=2db2f66e&scoped=true"
import script from "./data3.vue?vue&type=script&lang=js"
export * from "./data3.vue?vue&type=script&lang=js"
import style1 from "./data3.vue?vue&type=style&index=1&id=2db2f66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2f66e",
  null
  
)

export default component.exports